import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { LogIn, Feather } from "lucide-react";

// 로그인 리디자인(2026-07-18 피드백 — "친근하게, 파랑으로, 로그인하고 싶게") —
// 자물쇠 아이콘 대신 대시보드 헤더와 같은 N 로고 마크, 검정 버튼 대신 브랜드 블루,
// 카드 등장 페이드인 + 버튼 호버 리프트로 부드러운 인상. 본체 서비스 블루 톤 통일.
export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn, loading, error } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    const r = await signIn(email, password);
    if (r.success) {
      const next = location.state?.from || "/briefing";
      navigate(next, { replace: true });
    }
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-b from-brand-50/60 via-ink-50 to-ink-50 px-4">
      {/* 배경 광원 — 아주 느리게 부유하는 옅은 블루, 화면에 깊이만 더한다(꾸안꾸). */}
      <div aria-hidden className="float-soft pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-brand-200/40 blur-3xl" />
      <div aria-hidden className="float-soft pointer-events-none absolute -bottom-28 -right-20 h-80 w-80 rounded-full bg-brand-100/60 blur-3xl" style={{ animationDelay: "2.5s" }} />

      <div className="relative w-full max-w-sm animate-fade-in rounded-2xl bg-white p-7 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_16px_48px_-16px_rgba(37,99,235,0.18)]">
        <div className="mb-6 text-center">
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-brand-500 text-lg font-bold text-white shadow-[0_4px_12px_rgba(59,130,246,0.35)]">
            N
          </span>
          <div className="mt-3 text-xl font-bold tracking-tight text-ink-900">
            Nova <span className="font-normal text-ink-500">Backoffice</span>
          </div>
          {/* 입장 연출 — 만년필이 잉크 밑줄을 한 번 긋고 화면 밖으로 사라진다. */}
          <div className="relative mx-auto -mb-1 mt-0.5 h-8 w-44">
            <svg viewBox="0 0 176 32" className="absolute inset-0 h-full w-full">
              <path
                d="M8 22 C 34 14, 52 26, 78 20 S 128 12, 168 18"
                fill="none"
                stroke="#3B82F6"
                strokeWidth="2.5"
                strokeLinecap="round"
                className="ink-draw-once"
              />
            </svg>
            <Feather className="pen-fly-once absolute left-1 top-0 h-5 w-5 text-brand-600" />
          </div>
          <div className="text-sm text-ink-500">오늘의 숫자, 바로 확인하세요</div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3.5">
          <label className="block text-sm">
            <div className="mb-1.5 font-medium text-ink-700">이메일</div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              placeholder="admin@sedaily.com"
              className="w-full rounded-xl border border-ink-200 bg-ink-50/50 px-3.5 py-2.5 text-ink-900 transition-colors placeholder:text-ink-300 focus:border-brand-400 focus:bg-white focus:outline-none focus:ring-4 focus:ring-brand-100"
            />
          </label>
          <label className="block text-sm">
            <div className="mb-1.5 font-medium text-ink-700">비밀번호</div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full rounded-xl border border-ink-200 bg-ink-50/50 px-3.5 py-2.5 text-ink-900 transition-colors placeholder:text-ink-300 focus:border-brand-400 focus:bg-white focus:outline-none focus:ring-4 focus:ring-brand-100"
            />
          </label>
          {error && (
            <div className="animate-fade-in rounded-xl bg-red-50 px-3.5 py-2.5 text-sm text-red-700">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading || !email || !password}
            className="mt-1 flex w-full items-center justify-center gap-2 rounded-xl bg-brand-600 px-4 py-3 text-sm font-semibold text-white shadow-[0_4px_14px_rgba(37,99,235,0.3)] transition-all hover:-translate-y-0.5 hover:bg-brand-500 hover:shadow-[0_6px_20px_rgba(37,99,235,0.35)] active:translate-y-0 disabled:translate-y-0 disabled:opacity-50 disabled:shadow-none"
          >
            <LogIn className="h-4 w-4" />
            {loading ? "확인 중…" : "로그인"}
          </button>
        </form>
        <p className="mt-5 text-center text-xs text-ink-400">허용된 관리자 계정만 접속할 수 있습니다</p>
      </div>
    </div>
  );
}
